import React from 'react';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

const TypographyParagraph = ({
	text,
	href,
	style,
	...otherProps
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<Text
			style={[
				styles.text,
				href && styles.href,
				style,
			]}
			{...otherProps}
		>
			{text}
		</Text>
	);
};

const createStyles = ({ ui: { colors, type } }) => ({
	text: {
		...type.bodySmall,
		color: colors.text,
	},
	href: {
		color: colors.accent,
		textDecorationLine: 'underline',
	},
});

export default TypographyParagraph;
